import React, { useState, useEffect } from "react";

import eclips from "../../assets/greenEclips.svg";
import { GetSubMData } from "../../store/subscriptionAtom";

import { useParams } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

function SubDetailsScroll(props) {
  const subDataStore = GetSubMData();
  const [tableData, setTableData] = useState([]);

  const { sub_id } = useParams();

  useEffect(() => {
    if (subDataStore.subscription_info?.length > 0) {
      let tempList = subDataStore.subscription_info?.map((item) => {
        return { ...item, checked: false };
      });
      setTableData(tempList.slice(0, 20));
    }
  }, [subDataStore]);

  function paginate(e) {
    let tempList = subDataStore?.subscription_info.slice(
      0,
      Number(e.target.value)
    );
    tempList = tempList?.map((item) => {
      return { ...item, checked: false };
    });
    setTableData([...tempList]);
  }

  function customFilter(code) {
    switch (code) {
      case "1":
        setTableData(subDataStore.subscription_info);
        break;
      case "2":
        const activeList = subDataStore?.subscription_info.filter(
          (item) => item.Subscription_Status_Id === 1
        );
        setTableData(activeList);
        break;
      case "3":
        const trialList = subDataStore?.subscription_info.filter(
          (item) => item.Subscription_Status_Id === 2
        );
        setTableData(trialList);
        break;
      case "4":
        const temp = subDataStore?.subscription_info.filter(
          (item) => item.Subscription_Status_Id === 4
        );
        setTableData(temp);
        break;
      default:
        break;
    }
  }

  const onCheckAll = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData((prev) => {
      return [...tableData];
    });
    props?.onSelection(tableData);
  };

  return (
    <>
      <section className="w-full min-w-[170px] max-w-[200px]">
        <div className="w-full">
          <div className="ml-0.5 mt-1 mr-2">
            <button className="w-full">
              <select
                onChange={(e) => customFilter(e.target.value)}
                className="mb-2 w-full max-w-xs text-xs text-gray-700 bg-white border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              >
                <option value={1}>All</option>
                <option value={2}>Active</option>
                <option value={3}>Trial</option>
                <option value={4}>Trial Expired in the Previous Week</option>
                <option value={5}>Trial Expiring in the Next Week</option>
                <option value={6}>Packing Materials</option>
              </select>
            </button>
          </div>

          {/* <div className="">
            {tableData?.map((sub, i) => {
              return (
                <div
                  onClick={() => props.viewItemDetails(sub.Subscription_Ref_No)}
                  key={i}
                  className="min-w-[220px]"
                >
                  <div className="card cursor hover:bg-filterColor border border-dark-1 m-1 ">
                    <div
                      container
                      spacing={1}
                      className={
                        "row " +
                        (sub_id == sub?.Subscription_Ref_No
                          ? "app_bg_color1 mb-2 cursor"
                          : "mb-2 cursor")
                      }
                    >
                      <div item xs={6} className="col ">
                        <div>
                          <div>
                            <label className="">
                              <input
                                onChange={(e) => onCheckAll(e, i)}
                                checked={sub?.checked ? sub?.checked : ""}
                                type="checkbox"
                                className="w-[2vh] h-[2vh]"
                              />
                            </label>
                            <span
                              onClick={() =>
                                props.viewItemDetails(sub.Subscription_Ref_No)
                              }
                              className="text-sm ml-2"
                            >
                              {sub?.Customer_First_Name}{" "}
                            </span>
                          </div>
                          <i className="text-dark">
                            Next Renewal on {sub?.Next_Billed_Date_String}{" "}
                          </i>
                        </div>
                      </div>
                      <div item xs={6} className=" col  ">
                        <div>
                          <CurrencyFormat
                            className="font-weight-bold"
                            value={sub?.Subscription_Amount?.toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"₦"}
                          />
                        </div>

                        <div
                          style={{
                            backgroundColor: "rgba(112, 204, 64, 0.1)",
                          }}
                          className="rounded-full  flex justify-between py-1 w-full mt-7 mr-2"
                        >
                          <div className="mt-1.5">
                            <img src={eclips} alt="" />
                          </div>
                          <div
                            style={{ color: "#70CC40" }}
                            className="text-xs ml-2 mr-2"
                          >
                            {sub?.Subscription_Status_Name}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div> */}
          <div className="h-[calc(100vh-60px)] w-full overflow-y-scroll scrollbar-thin scrollbar-track-gray-200">
            {tableData?.map((sub, i) => (
              <div
                key={i}
                onClick={() => props.viewItemDetails(sub.Subscription_Ref_No)}
                className=""
              >
                <div
                  className={`border-b-[1px] border-gray-300 cursor-pointer transition px-2 py-2 ${
                    sub_id == sub?.Subscription_Ref_No
                      ? "bg-gray-200 border-b-blue-400"
                      : "bg-white hover:!bg-gray-100"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <label className="flex items-center text-sm text-gray-700">
                      <input
                        type="checkbox"
                        onChange={(e) => onCheckAll(e, i)}
                        checked={sub?.checked || false}
                        className="w-3.5 h-3.5 text-blue-600 z-10 border-gray-300 rounded-sm ring-0 checked:ring-0 focus:ring-0 ring-offset-0"
                      />
                      <span
                        title={sub?.Customer_First_Name}
                        className="ml-2 text-gray-700 truncate max-w-[70px]"
                      >
                        {sub?.Customer_First_Name}
                      </span>
                    </label>
                    <div className="text-[11px] text-gray-400 text-right">
                      <span className="font-medium">Next Sub:</span>
                      <div className="italic text-gray-700">
                        {sub?.Next_Billed_Date_String}
                      </div>
                    </div>
                  </div>

                  <div className="mt-1 flex flex-row items-center justify-between text-sm font-bold text-gray-800">
                    <CurrencyFormat
                      value={sub?.Subscription_Amount?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                    <div className="mt-2 w-fit flex items-center font-normal bg-green-50 rounded-full px-2 pb-0.5">
                      <img src={eclips} alt="" className="h-2 w-2" />
                      <span className="text-[11px] font-medium text-green-600 ml-1 truncate">
                        {sub?.Subscription_Status_Name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="clearfix mt-3 ml-2 text-center">
          <select onChange={paginate}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </section>
    </>
  );
}

export default SubDetailsScroll;
